export class CurrentUserProfile {
  details: {
    id: number;
    name: string;
    role: string[];
  };
}
